import { useState } from 'react';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import EditIcon from '../../assets/EditIcon';
import Accordion from '../../components/common/Accordian';
import useBgColorStore from '../../store/bgColor';
import { IUpComingStaffCompliance } from '../../type/upComingStaffCompliance';
import StaffComplianceCard from './StaffCompliaceCard';
import ViewStaffComplianceForm from '../common/ViewStaffComplianceForm';
import EditIconDark from '../../assets/EditIconDark';

interface UpComingStaffComplianceProps {
  upcomingStaffCompliance: IUpComingStaffCompliance[];
  userCanEditStaffCompliance?: boolean;
  refetchComplianceDetails: () => void;
  userHavePermissionToUpdateStatusStaffCompliance?:boolean;
  userHavePermissionToReadStatusStaffCompliance?:boolean;
}

export default function UpComingStaffCompliance({
  upcomingStaffCompliance,
  userCanEditStaffCompliance,
  refetchComplianceDetails,
  userHavePermissionToReadStatusStaffCompliance
}: UpComingStaffComplianceProps) {
  const { bgColor } = useBgColorStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStaff, setSelectedStaff] =
    useState<IUpComingStaffCompliance | null>(null);

  const handleEditClick = (staff: IUpComingStaffCompliance) => {
    setSelectedStaff(staff);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedStaff(null);
  };

  return (
    <>
      <div className="mt-6">
        <Accordion
          title="Upcoming Staff Compliances"
          iconOpen={
            <div>
              <div className="block dark:hidden">
                <AccordianDownIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianDownIconDark />
              </div>
            </div>
          }
          iconClose={
            <div>
              <div className="block dark:hidden">
                <AccordianUpIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianUpIconDark />
              </div>
            </div>
          }
          bgColor={bgColor}
          accordionIsOpen={true}
        >
          {upcomingStaffCompliance.map((res, index) => (
            <Accordion
              key={index}
              title={res?.allocatedStaffName}
              bgColor="bg-backgroundColor-darkThemeColor"
              status=""
              icon={
                userCanEditStaffCompliance ? (
                  <div
                    onClick={() => handleEditClick(res)}
                    className="cursor-pointer"
                  >
                    <div>
                      <div className="block dark:hidden">
                        <EditIcon />
                      </div>
                      <div className="hidden dark:block">
                        <EditIconDark />
                      </div>
                    </div>
                  </div>
                ) : undefined
              }
            >
              <StaffComplianceCard
                compliance={res?.complianceDescription}
                category={res?.status}
                status={
                  res?.status == 'Onboarding' ? res?.status : res?.displayText
                }
                allocatedTo={res?.allocatedStaffName}
                complianceId={res?.complianceId}
                complianceCategoryStatus={res?.complianceCategoryStatus}
                name={res?.staffName}
                recurrency={res?.concurrencyDescription}
                complianceLink={res?.staffExternalLink || undefined}
                staffId={res?.staffId}
                note={res.note}
                nextComplianceDate={res?.nextComplianceDate}
                lastComplianceDateDisplay={res?.lastComplianceDate}
                isEditMode={
                  selectedStaff?.complianceId === res.complianceId &&
                  isModalOpen
                }
                refetchComplianceDetails={refetchComplianceDetails}
                isUserCanEditStaffCompliance={res?.isUserCanEditStaffCompliance}
                parentStaffId={res?.staffId}
                upcomingDays={res?.upcomingDays}
                userHavePermissionToReadStatusStaffCompliance={userHavePermissionToReadStatusStaffCompliance}
              />
            </Accordion>
          ))}
        </Accordion>
      </div>
    </>
  );
}
